// extracted by mini-css-extract-plugin
module.exports = {"officeTabs":"Reception_officeTabs__9Zs6a","chooseBetweenOffices":"Reception_chooseBetweenOffices__NnV2_","singleTab":"Reception_singleTab__UcxyE"};